import {ActionKeys, CreateValue} from "../Ability";

export const DefaultAbility = ({can: allow, cannot: notAllow, rules}, {isAdmin, isSystem}, subWorkspace) => {

    const key = subWorkspace.key
    const isCreate = subWorkspace?.create?.createValue === CreateValue.TRUE
    const isView = subWorkspace?.enable

    allow([ActionKeys.READ], key, () => isView)
    allow([ActionKeys.CREATE, ActionKeys.UPDATE, ActionKeys.DELETE], key, () => isCreate)
}